














import { defineComponent } from '@vue/composition-api';
import { container } from 'tsyringe';

import Quiz from './Component.vue';
import { questions } from './sample';
import { ModelManager } from '../model';

export default defineComponent({
  name: 'QuizContainer',
  props: {
    modelId: { type: String, default: 'quiz' },
  },
  components: {
    Quiz,
  },
  setup(props) {
    const modelManager = container.resolve(ModelManager);

    const quizModel = modelManager.get(props.modelId, 'QuizModel');

    quizModel.setup(questions);

    return {
      questions,
      quizModel,
    };
  },
});
